// Local storage keys for session data
export const SESSION_KEY = 'session';
export const LATEST_SESSION_UPDATE_TIME_KEY = 'latest-session-update-time';

// Local storage keys for activity data
export const LATEST_ACTIVITY_TIME_KEY = 'last-activity-time';

// Usage reporting grace period in milliseconds (5 minutes)
const minuteInMs = 60 * 1000;
const gracePeriodInMinutes = 5;
export const USAGE_REPORTING_GRACE_PERIOD_MS =
  gracePeriodInMinutes * minuteInMs;

// Heartbeat / Usage reporting update interval in milliseconds (1 minute)
export const UPDATE_INTERVAL_MS = minuteInMs;

// List of events to track for activity
export const TRACKED_ACTIVITY_EVENTS = [
  // Keyboard navigation and screen reader interaction
  'keydown',
  'focusin',
  // Mouse/touch interactions
  'mousedown',
  'touchstart',
  // Form interactions
  'change',
  'input',
  // Generic interaction event
  'click',
  // Scroll event (will be throttled)
  'scroll',
] as const;

// List of keyboard events to track for activity
export const TRACKED_KEYBOARD_EVENTS = [
  'Tab',
  'Enter',
  'Space',
  'ArrowUp',
  'ArrowDown',
  'ArrowLeft',
  'ArrowRight',
];
